import QRCode from "qrcode";

export const generateQRCodeDataURL = async (data: string): Promise<string> => {
  try {
    return await QRCode.toDataURL(data, {
      width: 512, // Higher resolution for crisp printing
      margin: 2, // Slightly larger margin for better scanning
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
      errorCorrectionLevel: "M", // Medium error correction for better reliability
      type: "image/png", // PNG format for better quality
      quality: 1.0, // Maximum quality
      rendererOpts: {
        quality: 1.0, // Maximum rendering quality
      },
    });
  } catch (error) {
    console.error("Error generating QR code:", error);
    throw error;
  }
};

// High-resolution QR code specifically optimized for printing
export const generatePrintQRCodeDataURL = async (
  data: string
): Promise<string> => {
  try {
    return await QRCode.toDataURL(data, {
      width: 1024, // Very high resolution for crisp printing
      margin: 4, // Larger margin for better scanning reliability
      color: {
        dark: "#000000", // Pure black for thermal printers
        light: "#ffffff", // Pure white for thermal printers
      },
      errorCorrectionLevel: "H", // High error correction for damaged prints
      type: "image/png", // PNG format for lossless quality
      quality: 1.0, // Maximum quality
      rendererOpts: {
        quality: 1.0, // Maximum rendering quality
      },
    });
  } catch (error) {
    console.error("Error generating print QR code:", error);
    throw error;
  }
};
